export default __webpack_public_path__ + "static/media/venmo_qr_dark.53bd28b9.svg";